import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);
Vue.config.productionTip = false

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  var temp1 = vm == trace;
  if (msg === ignoreWarnMessage && !temp1) {
    msg = null;
    vm = null;
    trace = null
  }
}

App.vuetify = vuetify
Vue.customElement('course-calendar', App)
